import { ScrollTop as PrimeScrollTop, type ScrollTopProps } from 'primereact/scrolltop';
import { type ReactNode, type JSX } from 'react';

const ScrollTop = (
  props: JSX.IntrinsicAttributes &
    JSX.IntrinsicClassAttributes<PrimeScrollTop> &
    Readonly<ScrollTopProps> &
    Readonly<{ children?: ReactNode }>,
) => <PrimeScrollTop {...props} />;

export default ScrollTop;
